export enum LadingPaymentCode {
    Cash = "TM",
    Receiver = "NN",
    Debit = "GN"
}
